import { appRoutes } from './RoutesByRoles'
import { useRoutes } from 'react-router'

export const NotAuthRoutes = () => {
  return useRoutes(appRoutes.notAuthorized)
}
